import { render, staticRenderFns } from "./PpBaseHeaderSec.vue?vue&type=template&id=25aa74f2&scoped=true&"
import script from "./PpBaseHeaderSec.vue?vue&type=script&lang=js&"
export * from "./PpBaseHeaderSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa74f2",
  null
  
)

export default component.exports